import { Movement } from 'types';

export const getValidMovements = (movements: Movement[]) => {
  const duplicatedMovements = movements.filter(
    (movement, index, self) =>
      self.findIndex(
        (m) =>
          m.shareFrom === movement.shareFrom &&
          m.shareTo === movement.shareTo &&
          m.partner === movement.partner &&
          m.shareClass === movement.shareClass
      ) !== index
  );

  const validMovements = movements.filter(
    (movement) =>
      !duplicatedMovements.some(
        (dup) =>
          dup.shareFrom === movement.shareFrom &&
          dup.shareTo === movement.shareTo &&
          dup.partner === movement.partner &&
          dup.shareClass === movement.shareClass
      )
  );

  return validMovements;
};
